﻿'use strict'

import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as _ from 'underscore';
import * as Bootstrap from 'bootstrap';
//import * as mathjs from 'mathjs';

import tpl_shop from './tpl/shop.html';
import language from '../../../common/language';
import * as Entities_Empty from '../../../lib/entities/empty';
import View_Pagination from '../../../lib/views/pagination/pagination';
import View_ShopList from './shopList';
var template = require('../../js/template');

export default Marionette.LayoutView.extend({
    getTemplate: function () {
        return tpl_shop();
    },
    initialize: function () {
        this.app = this.options.app;
    },
    regions: {
        shopList: "#shopList",
        shopPagination: "#shopPagination"
    },
    onBeforeShow: function () {
        var self = this;

        this.shopList.show(new View_ShopList({ collection: this.collection, app : this.app }));
        this.shopPagination.show(new View_Pagination({ collection: this.collection, app : this.app }));
    },
    ui : {
        'shop_btnVat' : '#shop_btnVat',
        'shop_iVat' : '#shop_iVat',
        'shop_divVat' : '#shop_divVat'
    },
    events: {
        'click @ui.shop_btnVat': 'shop_btnVatClick'
    },
    onRender: function () {
        this.setupVat();
        this.recalculate();
    },
    onAttach(){
        template.render();
    },
    shop_btnVatClick: function (event) {
        event.preventDefault();

        this.app.entities.models.shopSetting.attributes.SelectedVat = !this.app.entities.models.shopSetting.attributes.SelectedVat;
        this.setupVat();

        this.recalculate();
    },
    setupVat: function () {
        if (this.app.entities.models.shopSetting.attributes.SelectedVat) {
            this.ui.shop_iVat.addClass('fa-check-square');
            this.ui.shop_iVat.removeClass('fa-square');
        } else {
            this.ui.shop_iVat.removeClass('fa-check-square');
            this.ui.shop_iVat.addClass('fa-square');
        }
    },
    round : function (x, currency) {
        switch (currency) {
            case 'DKK' : return Math.floor(x); break;//return this.round25(x); break;
            default : return x;
        }
    },
    round25 : function (x)
    {
        var number = (x < 0) ? Math.ceil(x) : Math.floor(x);
        //var fraction = Math.trunc((x - Math.trunc(x)) * 100);
        //var fraction = Math.abs((x - Math.abs(x)) * 100);

        //var fraction = Math.trunc(x * 100) - (number * 100);
        var fraction = Math.floor(x * 100) - (number * 100);
        

        var da_DK_fraction = 0;

        if (fraction >= 0 && fraction <= 24) da_DK_fraction = 0;
        else if (fraction >= 25 && fraction <= 74) da_DK_fraction = 0.5
        else if (fraction >= 75) da_DK_fraction = 1;

        var total = number + da_DK_fraction;

        return total;
    },
    recalculate : function () {
        var self = this;
        this.collection.forEach(function (entry) {
            entry.attributes.CalcPrice = self.round(entry.attributes.Price, entry.attributes.Currency);
            
            entry.attributes.ShowPrice = entry.attributes.CalcPrice;
            var PlanVat = (entry.attributes.ShowPrice * entry.attributes.Vat) - entry.attributes.ShowPrice;
            var PlanTotalPrice = entry.attributes.CalcPrice + PlanVat;

            if (self.app.entities.models.shopSetting.attributes.SelectedVat) {
                entry.attributes.ShowPrice = PlanTotalPrice;
            }

            entry.attributes.ShowPrice = Number(entry.attributes.ShowPrice).toFixed(2); 
        });

        this.collection.trigger('change');
    }
}, Backbone.Radio.Requests);